import { platformStats, posterRanks } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function PlatformSection() {
  return (
    <section id="platform" className="w-full bg-background-50">
      <div className="w-full px-4 py-10 md:px-6 md:py-14">
        <div className="mx-auto w-full max-w-[1220px]">
          <SectionHeading
            index="03"
            label="平台分布"
            title="最早出现在哪个平台，谁最容易抢先"
            desc="按归档事件统计各平台作为首发出处的占比，以及高频首发账号的时间领先率。"
          />

          <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-2">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <div className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-600 text-background-50">
                  <i className="ri-donut-chart-line"></i>
                </span>
                <span className="font-heading text-sm font-bold text-foreground-950">首发出处占比</span>
              </div>
              <ul className="mt-4 space-y-4">
                {platformStats.map((stat, index) => (
                  <li key={stat.name}>
                    <div className="flex flex-wrap items-center justify-between gap-1">
                      <span className="text-sm font-medium text-foreground-800">{stat.name}</span>
                      <span className="text-[11px] text-foreground-500">
                        {stat.count} 起 · {stat.percent}%
                      </span>
                    </div>
                    <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-background-200">
                      <div
                        className={`h-full rounded-full ${index === 0 ? "bg-primary-500" : "bg-secondary-500"}`}
                        style={{ width: `${stat.percent}%` }}
                      ></div>
                    </div>
                    <span className="mt-1.5 inline-block rounded bg-background-100 px-1.5 py-0.5 text-[10px] text-foreground-600">
                      {stat.role}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <div className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                  <i className="ri-user-star-line"></i>
                </span>
                <span className="font-heading text-sm font-bold text-foreground-950">谁爆的 · 首发账号领先率</span>
              </div>
              <ul className="mt-4 divide-y divide-background-200">
                {posterRanks.map((poster, index) => (
                  <li key={poster.name} className="flex items-center gap-3 py-3">
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full font-heading text-xs font-bold ${
                        index === 0 ? "bg-accent-500 text-foreground-950" : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      {index + 1}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="truncate text-sm font-medium text-foreground-800">{poster.name}</div>
                      <div className="mt-0.5 text-[11px] text-foreground-500">
                        {poster.role} · 归档 {poster.events} 起
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="font-heading text-sm font-bold text-primary-600">{poster.rate}</div>
                      <div className="text-[10px] text-foreground-500">时间领先</div>
                    </div>
                  </li>
                ))}
              </ul>
              <p className="mt-3 rounded-md bg-secondary-100 px-3 py-2 text-[11px] leading-relaxed text-secondary-900">
                领先率 = 该账号发布早于其他来源的比例。数值越高，越可能是最早出现的出处，但仍需结合时间戳与快照核实。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}